import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import CellValue from 'components/CellValue'
import {fieldtype} from 'utils/enums/fieldtype'
import {icons} from 'utils/enums/icons'

const Value = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 45px;
    line-height: 45px;
`

const Label = styled.div`
    font-weight: 600;
    margin: 10px 10px 0 10px;
    display: flex;
    align-items: center;
`

const Icon = styled.i`
    color: #a0b7be;
    font-size: 24px;
    padding-right: 10px;
`

const Field = styled.div`
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-color: rgba(160, 183, 190, 0.24);
    margin-top: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`

const FieldTypes = [
    fieldtype.text,
    fieldtype.textarea,
    fieldtype.email,
    fieldtype.phone,
    fieldtype.datetime,
    fieldtype.url,
    fieldtype.number,
    fieldtype.image,
    fieldtype.check,
    fieldtype.linkedfield
]

class BulkUpdateContent extends React.Component {
    constructor(props) {
        super(props)

        const tableFields = this.getTableFields(props.entity)

        this.state = {
            field: tableFields[0].id,
            type: tableFields[0].type,
            config: tableFields[0].config,
            value: undefined,
            tableFields
        }
    }

    handleChange = (event) => {
        const field = this.state.tableFields.find(item => item.id === event.target.value)

        this.setState({
            field: field.id,
            type: field.type,
            config: field.config,
            value: undefined
        })
    }

    getTableFields = (tableId) => {
        const table = this.props.entities.find(entity => entity.id === tableId)
        const fields = table.fields.filter(item => FieldTypes.indexOf(item.uiType) !== -1)
        return fields.map(field => {
            return {
                id: field.id,
                singular: field.singular,
                type: field.uiType,
                config: field.uiConfig
            }
        })
    }

    handleUpdateValue = (value, name) => {
        console.log(value)
        this.setState({
            value: value
        })
    }

    handleBulkUpdate = () => {
        this.props.documentsUpdate(this.state.field, this.state.value)
    }

    render() {
        const {intl} = this.props
        const singular = this.state.tableFields.find(item => item.id === this.state.field).singular

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "table.bulk_update"})}
                </DialogTitle>
                <DialogContent>
                    <FormControl variant="standard" sx={{width: '100%'}}>
                        <InputLabel>{intl.formatMessage({id: "table.bulk_update_field"})}</InputLabel>
                        <Select
                            value={this.state.field}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'field'
                            }}
                        >
                            {this.state.tableFields.map((item, index) =>
                                <MenuItem key={index} value={item.id}>
                                    {item.singular}
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <Field>
                        <Label>
                            <Icon className={icons[this.state.type]} />
                            <span>{singular}</span>
                        </Label>
                        <Value>
                            <CellValue
                                defaultValue={this.state.type !== fieldtype.linkedfield ? this.state.value : undefined}
                                linkedRelation={this.state.type === fieldtype.linkedfield && this.state.value}
                                type={this.state.type}
                                config={this.state.config}
                                handleUpdateValue={this.handleUpdateValue}
                                name={this.state.field}
                            />
                        </Value>
                    </Field>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleCloseDialog} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button onClick={this.handleBulkUpdate} variant="contained" color="primary">
                        {intl.formatMessage({id: "app.confirm_update"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(BulkUpdateContent)
